<template>
  <el-tabs type="border-card">
    <el-tab-pane>
      <span slot="label"><i class="el-icon-date"></i> Route</span>
      Route
    </el-tab-pane>
    <el-tab-pane label="Config">Config</el-tab-pane>
    <el-tab-pane label="Role">Role</el-tab-pane>
    <el-tab-pane label="Task">Task</el-tab-pane>
  </el-tabs>
</template>
<style>
</style>
<script>
  import axios from 'axios'
  export default {
    name: 'ModelStudio',
    components: {

    },
    data: function () {
      return {

      }}



  }
</script>
